import React from "react";
import ReviewAboutCardSection4 from "./ReviewAboutCardSection4";

const ReviewAboutSection4 = () => {
  return (
    <div id="rating">
      <div className="flex slider  overflow-hidden">
        <ReviewAboutCardSection4
          image="https://creazilla-store.fra1.digitaloceanspaces.com/cliparts/26592/face-man-clipart-md.png"
          image1="https://cdn-icons-png.flaticon.com/512/8909/8909899.png"
          para="   I am happy that I choose 'Alphakids' for my daughters pre-school as in the last 3 yrs I have seen her develop into this energetic, friendly, positive & loving child."
          title="SANDEEP "
          title1="12 JANUARY"
        />
        <ReviewAboutCardSection4
          image="https://cdn-icons-png.flaticon.com/128/2347/2347355.png"
          image1="https://cdn-icons-png.flaticon.com/512/8909/8909899.png"
          para=" I really admire the patience of every teacher & their passion to work with little children. As a parent I want to say a big 'Thank You' to the entire school management, as it’s their collective effort to provide the best school for any child."
          title="POOJA"
          title1="4 FEBRUARY"
        />
        <ReviewAboutCardSection4
          image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSKJtR5b_rcF9PQVNfedyBbZR6od9eVDiyNMw&usqp=CAU"
          image1="https://cdn-icons-png.flaticon.com/512/8909/8909899.png"
          para="Teachers are passionate about seeing their students succeed. They are so great about sharing moments of pride they see within your child – their good behaviors and achievements; and they know the importance of getting the parents involved should an issue arise, and do it in a very respectful, approachable manner."
          title="ADITYA"
          title1="13 MARCH"
        />
        <ReviewAboutCardSection4
          image="https://us.123rf.com/450wm/vectorkif/vectorkif1902/vectorkif190200052/116556273-face-expression-of-woman-in-blue-blouse-happy-female-emotion-beautiful-cartoon-character-vector.jpg?ver=6"
          image1="https://cdn-icons-png.flaticon.com/512/8909/8909899.png"
          para="A broad participation and sufficient control over a student's work;"
          title="RUHI"
          title1="8 APRIL"
        />
        <ReviewAboutCardSection4
          image="https://media.istockphoto.com/id/1081125770/vector/face-expression-of-woman-with-blond-hair.jpg?s=612x612&w=0&k=20&c=mN-oV1RNH964Hu8s8Qjie8tOf6Awyf6e-sYUjR_RnOk="
          image1="https://cdn-icons-png.flaticon.com/512/8909/8909899.png"
          para="Teachers are passionate about seeing their students succeed. They are so great about sharing moments of pride they see within your child – their good behaviors and achievements; and they know the importance of getting the parents involved should an issue arise, and do it in a very respectful, approachable manner.
          "
          title="ANAMIKA"
          title1="9 APRIL"
        />
        <ReviewAboutCardSection4
          image="https://cdn-icons-png.flaticon.com/128/2347/2347298.png"
          image1="https://cdn-icons-png.flaticon.com/512/8909/8909899.png"
          para="Great school!!! My kids are very happy to be at this school. Teachers are very nice and helpfull. This school is home for our family."
          title="TANVI"
          title1="10 MAY"
        />
      </div>
    </div>
  );
};

export default ReviewAboutSection4;
